import React, { useState, forwardRef, useEffect, useLayoutEffect } from 'react';
import moment from 'moment';
import NextArrow from '../../images/priva-nav-right.png';
import PrevArrow from '../../images/priva-nav-left.png';
import PostFooter from './post-footer';
import PVideo from '../PVideo';
import { CARD_ERRORS, FOLLOW_TIER, NUT_THEME_USERS, ORIENTATION, POST_STATUS, POST_TYPE, ROLES, s3Link } from '../../utils/constants';
import Avatar from '../Avatar';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Pinned from '../../images/pin-blue.png';
import Duration from '../Duration';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from "swiper";
import LockIcon from '../../images/silver-app.png';
import PriceText from '../PriceText';
import CountDownTimer from '../CountDownTimer';

import '../jquery';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import './style.scss';
import './mobile-style.scss';
import './fancybox-styles.scss';
import './carousel-style.scss';
import './overrides.scss';

import fancybox from "@fancyapps/fancybox";
import '@fancyapps/fancybox/src/css/core.css';
import { isMobile } from 'react-device-detect';
import { connect, useDispatch } from 'react-redux';
import currency from 'currency.js';
import { getFirstSegment, inFreeTiers, postTypeNeedsSubscription, showImageCounter, showPrice, showVideoCounter } from '../../utils/helper';
import PostActions from './pu-post-actions';
import SilverLockIcon from '../../images/silver-app.png';
import UnlockPurchaseButton from './unlock-purchase-button';
import SuPostActions from "./su-post-actions";
import Thumbprint from "../Thumbprint";
import { setPost } from '../../../redux/actions/post';
import UpgradeToUnlock from '../UpgradeToUnlock';
import { CircularProgress } from '@mui/material';

const checkAspectRatio = (ratio) => {
    if (parseFloat(ratio) >= .58 && parseFloat(ratio) < .90) {
        return (' p_3_4');
    } else if (parseFloat(ratio) >= .42 && parseFloat(ratio) <= .57) {
        return (' p_9_16');
    } else if (parseFloat(ratio) <= .41) {
        return (' p_9_22');
    } else if (parseFloat(ratio) == 1) {
        return (' p_1_1');
    } else if (parseFloat(ratio) == 1.33) {
        return (' l_3_4');
    } else if (parseFloat(ratio) >= 1.34 && parseFloat(ratio) <= 2.43) {
        return (' l_9_16');
    } else if (parseFloat(ratio) >= 2.44) {
        return (' l_9_22');
    } else {
        return (' p_1_1');
    }
};

const Media = React.memo(({
    media,
    hasPortrait,
    hasEqual,
    post,
    autoplay = false,
    showBlurred = false,
    showMultiple = false,
    containerClass = '',
    needsSubscription = false,
    isFreeFollow = { isFreeFollow }
}) => {
    const user = JSON.parse(localStorage.getItem('user'));

    const [isVideo, setIsVideo] = useState(false);
    const [aspectRatioClass, setAspectRationClass] = useState('');

    useEffect(() => {
        let render = true;

        setAspectRationClass(checkAspectRatio(media.aspect_ratio));

        return (() => {
            render = false;
        });
    }, [media]);

    let orientationClass = 'media__auto';
    if (media.orientation == ORIENTATION.LANDSCAPE) {
        orientationClass = 'media__landscape';
    }

    if (media.orientation == ORIENTATION.PORTRAIT) {
        orientationClass = 'media__portrait';
    }

    if (media.orientation == ORIENTATION.EQUAL) {
        orientationClass = 'media__equal';
    }

    if (showBlurred) {
        return <div
            className={`post__image ${hasPortrait ? 'media__portrait' : (hasEqual ? 'media__equal' : 'media__landscape')}`}
        >
            <div className={`${aspectRatioClass ? aspectRatioClass : ''}`}>
                {
                    parseFloat(post.price) > 0 && !post.has_free_preview && !post.unlocked && <img src={LockIcon} className="post-ppv__lock-icon" />
                }

                <img onContextMenu={e => e.preventDefault()} src={`${s3Link}/${media.blurred_path}`} />
            </div>
        </div>;
    }


    if (showMultiple || needsSubscription) {
        return <div
            className={`post__image ${containerClass} post-ppv__multiple`}
        >
            <div className='post-ppv__multiple-lock'>
                <img src={LockIcon} />
            </div>
            <div className='post-ppv__multiple-unlock post__purchase'>
                {
                    needsSubscription && isFreeFollow
                        ? <UpgradeToUnlock
                            buttonClassname='btn btn-primary btn-rounded btn-post-ppv'
                            post={post}
                        />
                        : <UnlockPurchaseButton post={post} />
                }
            </div>
        </div>;
    }

    const handlePlayVideo = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsVideo(true);
    };

    // add checking of ratio and add class
    if (media.type.toUpperCase() === 'VIDEO') {
        let imgSrc = media.thumb_path;

        if (media.large_path) {
            imgSrc = media.large_path;
        }

        if (!imgSrc) {
            imgSrc = media.file_path;
        }

        if (needsSubscription) {
            imgSrc = media.blurred_path;
        }

        const HiddenVideo = () => {
            return <div
                onContextMenu={e => e.preventDefault()}
                id={`media-${post.id}-${media.media_id}`}
                style={{
                    display: 'none',
                    padding: 0
                }}
                className={`${media.orientation == ORIENTATION.PORTRAIT ? 'hidden-media__portrait' : (media.orientation == ORIENTATION.EQUAL ? 'hidden-media__equal' : 'hidden-media__landscape')}`}>
                <PVideo
                    thumb={media.thumb_path ? `${s3Link}/${media.thumb_path}` : ''}
                    video={`${s3Link}/${media.file_path}`}
                    preload="meta"
                    className="embed-responsive-item"
                    autoplay={autoplay}
                    muted={true}
                    style={{ width: '100%' }}
                    onContextMenu={e => e.preventDefault()}
                    duration={media.vid_duration}
                />
            </div>;
        };

        return !isVideo ? <div
            className={`video-thumb ${hasPortrait ? 'media__portrait' : (hasEqual ? 'media__equal' : 'media__landscape')}`}
            style={{ postition: 'relative' }}
        >
            <a
                className="cust-fancybox"
                data-fancybox={'media-slider' + `${post.id}`}
                data-protect="true"
                data-src={`#media-${post.id}-${media.media_id}`}
            >
                <div
                    className={`post__image`}
                >
                    <div className={`${aspectRatioClass ? aspectRatioClass : ''}`}>
                        <img onContextMenu={e => e.preventDefault()} src={`${s3Link}/${imgSrc}`} />
                    </div>
                </div>

                <HiddenVideo />
            </a>
            <span className="play-icon" style={{ zIndex: 99 }} onClick={handlePlayVideo}>
                <FontAwesomeIcon icon={['fas', 'play']} />
            </span>

            <Duration duration={media.vid_duration} />
        </div>
            : <div
                className={`is-video`}
                onContextMenu={e => e.preventDefault()}
            >
                <div className={`${aspectRatioClass ? aspectRatioClass : ''}`}>
                    <a
                        className="cust-fancybox"
                        data-fancybox={'media-slider' + `${post.id}`}
                        data-protect="true"
                        style={{ width: '100%' }}
                        href="#"
                        onContextMenu={e => e.preventDefault()}
                        data-src={`#media-${post.id}-${media.media_id}`}
                    >
                        <PVideo
                            thumb={imgSrc ? `${s3Link}/${imgSrc}` : ''}
                            video={`${s3Link}/${needsSubscription ? media.blurred_path : media.file_path}`}
                            preload="meta"
                            className="embed-responsive-item"
                            autoplay={true}
                            muted={true}
                            style={{ width: '100%', zIndex: 99 }}
                            onContextMenu={e => e.preventDefault()}
                            duration={media.vid_duration}
                        />
                        <HiddenVideo />
                    </a>
                </div>
            </div>;
    } else if (media.type.toUpperCase() === 'IMAGE') {
        let imgSrc;

        if (media.large_path) {
            imgSrc = media.large_path;
        } else {
            imgSrc = media.thumb_path;
        }

        if (needsSubscription) {
            imgSrc = media.blurred_path;
        }

        return <div
            className={`post__image ${hasPortrait ? 'media__portrait' : (hasEqual ? 'media__equal' : 'media__landscape')}`}
        >
            <div className={`${aspectRatioClass ? aspectRatioClass : ''}`}>
                {(user.id !== post.pu_id) && <div className={'post-thumbprint-container'}><Thumbprint /></div>}
                <img onContextMenu={e => e.preventDefault()} src={`${s3Link}/${imgSrc}`} />
            </div>
        </div>;
    } else {
        return <div>Unknown media.</div>;
    }
});

const PostItem = forwardRef(({
    posts,
    post,
    pu, //pu from server not from localhost
    refetch,
    setRefetch,
    setActiveComment,
    autoplay = false,
    activePost
}, ref) => {
    const [comment, setComment] = useState(false);
    const [shortCaption, setShortCaption] = useState('');
    const [hasPortrait, setHasPortrait] = useState(false);
    const [hasEqual, setHasEqual] = useState(false);
    const [hasLandscape, setHasLandscape] = useState(false);
    const [currentCategories, setCurrentCategories] = useState(post.categories || []);
    const [categoryEditMode, setCategoryEditMode] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const [containerAspectRatio, setContainerAspectRatio] = useState('');
    const [currentPost, setCurrentPost] = useState(post);
    const [isDiscounted, setIsDiscounted] = useState(false);
    const [isFreeFollow, setIsFreeFollow] = useState(false);
    const [needsSubscription, setNeedsSubscription] = useState(false);

    const userInformation = JSON.parse(localStorage.getItem('user'));

    const dispatch = useDispatch();

    const firstSegment = getFirstSegment();

    useLayoutEffect(() => {
        $.fancybox.defaults.afterShow = () => {
            document.body.style.overflowY = "hidden";
        };
        $.fancybox.defaults.afterClose = () => {
            document.body.style.overflowY = "auto";
        };
        $.fancybox.defaults.hash = false;
        $.fancybox.defaults.protected = true;
        $.fancybox.defaults.loop = true;
        $.fancybox.defaults.slideShow = false;
        $.fancybox.defaults.smallBtn = false;
        $.fancybox.defaults.idleTime = false;
        $.fancybox.defaults.hideScrollbar = true;
        $.fancybox.defaults.closeExisting = false;
        $.fancybox.defaults.mobile = {
            clickSlide: 'close'
        };
        $.fancybox.defaults.touch = {
            vertical: false
        },
            $.fancybox.defaults.clickContent = (current, event) => current.type === 'image' ? 'zoom' : false;
    }, []);

    const [numImages, setNumImages] = useState(0);
    const [numVideos, setNumVideos] = useState(0);
    useEffect(() => {
        setCurrentCategories(post.categories);

        let imagesTotal = 0;
        let videosTotal = 0;

        post.medias && post.medias.forEach(media => {
            if (media.type.toLowerCase() === 'video') {
                videosTotal += 1;
            }

            if (media.type.toLowerCase() === 'image') {
                imagesTotal += 1;
            }
        });

        setNumVideos(videosTotal);
        setNumImages(imagesTotal);

        if (post.promo_price > 0 && post.expire_at) {
            const expiry = moment.utc(post.expire_at).local();
            if (moment().isSameOrAfter(expiry, 'seconds')) {
                setIsDiscounted(false);
            } else {
                setIsDiscounted(true);
            }
        }

        setIsFreeFollow(inFreeTiers(post.tier));
        setNeedsSubscription(postTypeNeedsSubscription(post.post_type));
    }, [post]);

    useEffect(() => {
        const onMessageFromFooter = () => {
            setCategoryEditMode(true);
        };

        window.addEventListener('footer/add-to-album/' + post.id, onMessageFromFooter);

        return () => {
            window.removeEventListener('footer/add-to-album/' + post.id, onMessageFromFooter);
        };
    }, []);

    useEffect(() => {
        const onCategoryChanged = ({ detail }) => {
            if (categoryEditMode === true) {
                setCurrentCategories(detail);
            }
        };

        const onHideCategoryModal = () => {
            // on cancel
            setTimeout(() => {
                setCurrentCategories(post.categories);
                setCategoryEditMode(false);
            }, 10);
        };

        const onConfirmCategoryModal = () => {
            setCategoryEditMode(false);
        };


        if (categoryEditMode === true) {
            window.addEventListener('wall-album/checkchange', onCategoryChanged);
            window.addEventListener('category-modal/hide', onHideCategoryModal);
            window.addEventListener('category-modal/confirm', onConfirmCategoryModal);
        } else {
            window.removeEventListener('wall-album/checkchange', onCategoryChanged);
            window.removeEventListener('category-modal/hide', onHideCategoryModal);
            window.removeEventListener('category-modal/confirm', onConfirmCategoryModal);
        }

        return () => {
            window.removeEventListener('wall-album/checkchange', onCategoryChanged);
            window.removeEventListener('category-modal/hide', onHideCategoryModal);
            window.removeEventListener('category-modal/confirm', onConfirmCategoryModal);
        };
    }, [categoryEditMode]);

    const Caption = ({ post }) => {
        const [showMore, setShowMore] = useState(false);

        useEffect(() => {
            if (post.caption && post.caption.split(" ").length > maxWords) {
                setShortCaption(truncate(post.caption, maxWords));
            }
        }, [post]);

        const toggleShowCaption = e => {
            e.preventDefault();
            setShowMore(showMore => !showMore);
        };

        const truncate = (str, no_words) => {
            return str.split(" ").splice(0, no_words).join(" ");
        };

        const maxWords = 45;

        if (shortCaption && !showMore) {
            return <React.Fragment>
                <div style={{ display: 'inline' }} dangerouslySetInnerHTML={{ __html: shortCaption }} />... <a href="#" onClick={toggleShowCaption}>See more</a>
            </React.Fragment>;
        } else if (shortCaption && showMore) {
            return <React.Fragment><div style={{ display: 'inline' }} dangerouslySetInnerHTML={{ __html: post.caption }} /> <a href="#" onClick={toggleShowCaption}>See less</a>
            </React.Fragment>;
        } else {
            return <React.Fragment><div style={{ display: 'inline' }} dangerouslySetInnerHTML={{ __html: post.caption }} />
            </React.Fragment>;
        }
    };

    useEffect(() => {
        if (post.medias && post.medias.length > 0) {
            const portraits = post.medias.filter(media => {
                return media.orientation == ORIENTATION.PORTRAIT;
            });

            setHasPortrait(hasPortrait => portraits.length > 0);

            const equal = post.medias.filter(media => {
                return media.orientation == ORIENTATION.EQUAL;
            });

            setHasEqual(hasEqual => equal.length > 0);

            const landscape = post.medias.filter(media => {
                return media.orientation == ORIENTATION.LANDSCAPE;
            });

            setHasLandscape(hasLandscape => landscape.length > 0);

            // check if post is paid
            let aspectRatios = [];

            if (parseFloat(post.price) > 0 && !post.unlocked) {
                aspectRatios = [checkAspectRatio(post.medias[0].aspect_ratio)];
            } else {
                aspectRatios = post.medias.map(media => checkAspectRatio(media.aspect_ratio));
            }

            if (aspectRatios.includes(' l_3_4')) {
                setContainerAspectRatio(' l_3_4');
            }

            if (aspectRatios.includes(' l_9_16')) {
                setContainerAspectRatio(' l_9_16');
            }

            if (aspectRatios.includes(' l_9_22')) {
                setContainerAspectRatio(' l_9_22');
            }

            if (aspectRatios.includes(' p_1_1')) {
                setContainerAspectRatio(' p_1_1');
            }

            if (aspectRatios.includes(' p_3_4')) {
                setContainerAspectRatio(' p_3_4');
            }

            if (aspectRatios.includes(' p_9_16')) {
                setContainerAspectRatio(' p_9_16');
            }

            if (aspectRatios.includes(' p_9_22')) {
                setContainerAspectRatio(' p_9_22');
            }
        }
    }, [post]);

    const callHandleAlbum = () => {
        setCategoryEditMode(true);
        window.dispatchEvent(new Event(`post/${post.id}/callAlbum`));
    };


    const isThemeblk = () => {
        return pu && NUT_THEME_USERS.includes(pu.id);
    };

    const handleEndTime = id => {
        let tmp = { ...post };
        tmp = {
            ...tmp,
            expiry_date: null,
            promo_price: null
        };

        dispatch(setPost({ ...tmp }));
        setIsDiscounted(false);
    };

    const RenderPostType = () => {
        switch (post.post_type) {
            case POST_TYPE.FREE:
                return 'Free post';

            case POST_TYPE.SUBSCRIPTION_POST:
                return 'Requires paid subscription';

            case POST_TYPE.PPV_WITH_FREE_SUBSCRIPTION:
                return <>
                    {
                        post.price > 0 && (userInformation.role === ROLES.PU || !post.unlocked)
                        && (
                            isDiscounted
                                ? <div className='post-list-item__price'><PriceText price={post.price} discountedPrice={post.promo_price} isDiscounted /></div>
                                : <div className='post-list-item__price'><PriceText price={post.price} /></div>
                        )
                    }PPV requires no subscription
                </>;

            case POST_TYPE.PPV_WITH_PAID_SUBSCRIPTION:
                return <>
                    {
                        post.price > 0 && (userInformation.role === ROLES.PU || !post.unlocked)
                        && (
                            isDiscounted
                                ? <div className='post-list-item__price'><PriceText price={post.price} discountedPrice={post.promo_price} isDiscounted /></div>
                                : <div className='post-list-item__price'><PriceText price={post.price} /></div>
                        )
                    }PPV requires paid subscription
                </>;

            default:
                return null;
        }
    };



    if (post && Object.keys(post).length <= 0) {
        return <CircularProgress />;
    }

    return (
        <div
            className={`${isThemeblk() ? "themeblk-posts-list-item" : "posts-list-item"} ${needsSubscription ? 'needs-subscription' : 'subs-not-needed'}`}
            id={`post-${post.id}`}
            ref={ref}
            data-type={post.post_type}
            data-tier={post.tier}
        >
            <div className="posts-list-item-header">
                {
                    post.user && <>
                        <div className="posts-list-item-img">
                            <Avatar
                                pu={pu}
                                size="70"
                            />
                        </div>
                        <div className="posts-list-item-data">
                            <p>
                                {post.user.firstname}
                                {' '}
                                <span><a href={post.user.login}>@{post.user.login}</a></span>
                            </p>
                            <p className="post-lists-item-data-date">{
                                post.status === POST_STATUS.PUBLISHED
                                    ? (post.sched_date
                                        ? moment.utc(post.sched_date).local().format('LLL')
                                        : moment.utc(post.created_at).local().format('LLL'))
                                    : moment(moment.utc(post.sched_date).local().format()).fromNow()
                            }</p>
                        </div>
                    </>
                }
                <div className="post-actions">
                    {
                        post.pinned && <div className="pin-profile-post">
                            <i className="fa-solid fa-thumbtack"></i>
                        </div>
                    }
                    {
                        userInformation && [ROLES.PU].includes(userInformation.role) && userInformation.id == currentPost.pu_id && <PostActions post={post} refetch={refetch} comment={comment} setRefetch={setRefetch} setActiveComment={setActiveComment} user={pu} />
                    }
                    {
                        userInformation && [ROLES.SU, ROLES.ADMIN].includes(userInformation.role) && userInformation.id != currentPost.pu_id && <SuPostActions post={post} refetch={refetch} comment={comment} setRefetch={setRefetch} setActiveComment={setActiveComment} user={pu} />
                    }
                </div>
            </div>
            {(currentCategories && Number(currentCategories.length) > 0) ? (
                <div className="cat-label-con">
                    <i className="fa-regular fa-rectangle-history ico-blue"></i>
                    {
                        userInformation.role === ROLES.PU
                            ? <div className="clickable-album" onClick={callHandleAlbum}>Albums</div>
                            : <div>Albums</div>
                    }
                    {currentCategories.map((item) => {
                        return (
                            <div key={item.id} className="cat-lbl-itm">{item.name}</div>
                        );
                    })}
                </div>
            ) : null}
            <div className="posts-list-item-content-container">
                <div className="posts-list-item-content">
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: [POST_TYPE.FREE, POST_TYPE.SUBSCRIPTION_POST].includes(parseInt(post.post_type)) || userInformation.role == ROLES.SU
                                ? 'flex-end'
                                : 'space-between',
                        }}
                    >
                        {
                            userInformation.role == ROLES.PU
                                ? <div style={{ padding: '0 15px' }}>
                                    <RenderPostType />
                                </div>
                                : null
                        }

                        {
                            [POST_TYPE.FREE, POST_TYPE.SUBSCRIPTION_POST].includes(parseInt(post.post_type)) && userInformation.role === ROLES.PU && (numImages > 0 || numVideos > 0)
                                ? <div style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    fontSize: '8px'
                                }}>
                                    <i className="fa-solid fa-circle"></i>
                                </div>
                                : null
                        }


                        <div className='post-list-item__stats'>
                            {showImageCounter(numImages)}
                            {showVideoCounter(numVideos)}
                        </div>
                    </div>
                    {
                        isDiscounted && userInformation.id === post.pu_id && <div className='post-list-item__expiry right'>
                            <span className="limited-offer-text">Limited offer expires in:
                                <CountDownTimer
                                    dateTime={post.expire_at}
                                    id={post.id}
                                    onEndTime={handleEndTime}
                                    isEmphasized={true}
                                    isUTC
                                />
                            </span>
                        </div>
                    }

                    {post.medias && post.medias.length > 0 &&
                        <div
                            className={`posts-list-slider ${hasPortrait ? 'container__portrait' : (hasEqual ? 'container__equal' : 'container__landscape')} ${containerAspectRatio} ${post.medias.length == 1 && post.medias[0].type.toUpperCase() == 'VIDEO' ? ' is-video' : ''}${((post.price > 0 && !post.unlocked && !post.has_free_preview) || needsSubscription) ? ' post-ppv' : ''}${post.medias.length > 1 && !post.unlocked && post.has_free_preview ? ' post-ppv-free-preview' : ''}${post.price > 0 ? ' post-ppv__container' : ''}${post.price > 0 && post.medias.length > 1 && !post.unlocked ? ' post-ppv__container-bundle-locked' : ''}`}
                        >
                            {/* ppv post */}
                            {
                                // with free preview regardless if single or bundle
                                (post.price > 0 && !post.unlocked && post.has_free_preview && ((isFreeFollow && post.post_type == POST_TYPE.PPV_WITH_FREE_SUBSCRIPTION) || !isFreeFollow))
                                    ? <div
                                        key={`single-media`}
                                        className="single-media text-center block"
                                        data-preview={post.has_free_preview}
                                    >
                                        {post.medias[0].type.toUpperCase() === 'IMAGE'
                                            ? <a className="cust-fancybox" data-src={`${s3Link}/${post.medias[0].file_path}`} data-fancybox={'media-slider' + `${post.id}`} data-protect="true">
                                                <Media
                                                    post={post}
                                                    media={post.medias[0]}
                                                    hasPortrait={hasPortrait}
                                                    hasEqual={hasEqual}
                                                    autoplay={autoplay}
                                                />
                                            </a>
                                            : null
                                        }
                                        {
                                            post.medias[0].type.toUpperCase() === 'VIDEO'
                                                ? <Media
                                                    post={post}
                                                    media={post.medias[0]}
                                                    hasPortrait={hasPortrait}
                                                    hasEqual={hasEqual}
                                                    autoplay={autoplay}
                                                />
                                                : null
                                        }

                                        <span className="post__free-preview-label">Free Preview</span>

                                        {
                                            needsSubscription && isFreeFollow
                                                ? <UpgradeToUnlock
                                                    buttonClassname='btn btn-primary btn-rounded btn-post-ppv'
                                                    post={post}
                                                />
                                                : <UnlockPurchaseButton post={post} />
                                        }

                                    </div>
                                    : null
                            }

                            {
                                // ppv with no free preview and has media
                                (
                                    (post.price > 0 && !post.unlocked && !post.has_free_preview && post.medias.length > 0)
                                    || (needsSubscription && isFreeFollow && post.medias.length > 0 && !post.has_free_preview)
                                    || (needsSubscription && isFreeFollow && post.medias.length > 0 && post.has_free_preview && post.post_type == POST_TYPE.PPV_WITH_PAID_SUBSCRIPTION)
                                )
                                    ? <div
                                        className="single-media text-center block"
                                        key={`single-media`}
                                    >
                                        <Media
                                            post={post}
                                            media={post.medias[0]}
                                            hasPortrait={hasPortrait}
                                            hasEqual={hasEqual}
                                            showBlurred={post.medias.length === 1}
                                            showMultiple={post.medias.length > 1}
                                            containerClass={containerAspectRatio}
                                            autoplay={autoplay}
                                            needsSubscription={needsSubscription}
                                            isFreeFollow={isFreeFollow}
                                        />

                                        {
                                            post.medias.length == 1
                                                ? (
                                                    needsSubscription && isFreeFollow
                                                        ? <UpgradeToUnlock
                                                            buttonClassname='btn btn-primary btn-rounded btn-post-ppv'
                                                            post={post}
                                                        />
                                                        : <UnlockPurchaseButton post={post} />
                                                )
                                                : null
                                        }
                                    </div>
                                    : null
                            }


                            {/* unlocked area */}
                            {post.medias.length > 1 && post.unlocked && !(needsSubscription && isFreeFollow)
                                ? <Swiper
                                    pagination={true}
                                    modules={[Pagination, Navigation]}
                                    navigation={!isMobile}
                                    className="post"
                                >
                                    {post.medias.map((media, index) => (
                                        <SwiperSlide key={`${media.media_id}-${index}`}>
                                            {media.type.toUpperCase() === 'IMAGE' &&
                                                <a
                                                    className="cust-fancybox"
                                                    data-src={`${s3Link}/${isFreeFollow && [POST_TYPE.PPV_WITH_PAID_SUBSCRIPTION, POST_TYPE.SUBSCRIPTION_POST].includes(post.post_type) ? media.blurred_path : media.file_path}`}
                                                    data-fancybox={'media-slider' + `${post.id}`}
                                                    data-protect="true"
                                                    style={{ width: '100%' }}
                                                >
                                                    <Media
                                                        post={post}
                                                        media={media}
                                                        hasPortrait={hasPortrait}
                                                        hasEqual={hasEqual}
                                                        autoplay={autoplay}
                                                    />
                                                </a>
                                            }
                                            {media.type.toUpperCase() === 'VIDEO' &&
                                                <Media
                                                    post={post}
                                                    media={media}
                                                    hasPortrait={hasPortrait}
                                                    hasEqual={hasEqual}
                                                    autoplay={autoplay}
                                                />
                                            }

                                            {
                                                media.pivot && media.pivot.length > 0 && media.pivot.free_preview ? <span className="post__free-preview-label">Free Preview</span> : ''
                                            }
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                                : null
                            }
                            {
                                post.medias.length === 1 && post.unlocked && !(needsSubscription && isFreeFollow)
                                    ? <>
                                        {post.medias.map((media, index) => (
                                            <div className="single-media text-center block" key={`single-media-${index}`}>
                                                {media.type.toUpperCase() === 'IMAGE' &&
                                                    <a className="cust-fancybox" data-src={`${s3Link}/${media.file_path}`} data-fancybox={'media-slider' + `${post.id}`} data-protect="true">
                                                        <Media
                                                            post={post}
                                                            media={media}
                                                            hasPortrait={hasPortrait}
                                                            hasEqual={hasEqual}
                                                            autoplay={autoplay}
                                                        />
                                                    </a>
                                                }
                                                {media.type.toUpperCase() === 'VIDEO' &&
                                                    <Media
                                                        post={post}
                                                        media={media}
                                                        hasPortrait={hasPortrait}
                                                        hasEqual={hasEqual}
                                                        autoplay={autoplay}
                                                    />
                                                }
                                            </div>
                                        ))}
                                    </>
                                    : null
                            }
                        </div>
                    }
                    {!post.caption && (post.medias && post.medias.length > 1) && <div style={{ marginTop: '5px' }}></div>}
                    {!post.caption && (post.medias && post.medias.length > 0) && <div style={{ marginTop: '5px' }}></div>}

                    {post.caption && <div className="post__caption"
                        style={
                            post.caption && (post.medias && post.medias.length <= 1)
                                ? { paddingTop: '5px', paddingBottom: '3px' }
                                : { paddingTop: '2px', paddingBottom: '3px' }}>
                        <Caption post={post} />
                    </div>
                    }
                </div>
            </div>
            <PostFooter
                post={post}
                comment={comment}
                refetch={refetch}
                // setRefetch={setRefetch}
                setActiveComment={setActiveComment}
                user={pu}
            />
        </div>
    );
});

const mapStateToProps = (state) => {
    return {
        activePost: state.post.selectedPost
    };
};


export default React.memo(connect(mapStateToProps, null, null, { forwardRef: true })(PostItem));

